<!-- ClassNumberChart.vue -->
<template>
  <div ref="chartRef" class="chart"></div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import * as echarts from 'echarts';

const chartRef = ref(null);
let chart = null;

/* ---------- 数据：直接复用 Teacher.vue 里的 teacherData ---------- */
const teacherData = [
  {
    key: '1',
    segment: '幼儿园',
    2015: 2442,
    2016: 2587,
    2017: 2854,
    2018: 3165,
    2019: 3592,
    2020: 4070,
    2021: 4232,
    2022: 4517,
    2023: 4362,
    2024: 4024,
    2025: 3636,
    2026: 3321,
    2027: 3330,
    2028: 3277,
    2029: 3185,
    2030: 3026,
    2031: 2956,
    2032: 2887,
    2033: 2820,
    2034: 2786,
    2035: 2785,
  },
  {
    key: '2',
    segment: '小学',
    2015: 10781,
    2016: 10687,
    2017: 10563,
    2018: 10466,
    2019: 10436,
    2020: 10450,
    2021: 10363,
    2022: 10085,
    2023: 10040,
    2024: 9902,
    2025: 9821,
    2026: 9967,
    2027: 9731,
    2028: 9332,
    2029: 8444,
    2030: 7834,
    2031: 7332,
    2032: 6978,
    2033: 6802,
    2034: 6723,
    2035: 6650,
  },
  {
    key: '3',
    segment: '初中',
    2015: 6565,
    2016: 6598,
    2017: 6644,
    2018: 6552,
    2019: 6467,
    2020: 6444,
    2021: 6374,
    2022: 6164,
    2023: 6008,
    2024: 5869,
    2025: 5898,
    2026: 6127,
    2027: 6051,
    2028: 6058,
    2029: 6575,
    2030: 6920,
    2031: 7033,
    2032: 6323,
    2033: 5669,
    2034: 5034,
    2035: 4584,
  },
  {
    key: '4',
    segment: '普通高中',
    2015: 2650,
    2016: 2724,
    2017: 2864,
    2018: 2946,
    2019: 3083,
    2020: 3110,
    2021: 3170,
    2022: 3162,
    2023: 3149,
    2024: 3129,
    2025: 3109,
    2026: 3317,
    2027: 3427,
    2028: 3558,
    2029: 3566,
    2030: 3623,
    2031: 3993,
    2032: 4257,
    2033: 4381,
    2034: 3982,
    2035: 3594,
  },
];

/* ---------- 图表数据处理 ---------- */
const prepareChartData = () => {
  const years = Array.from({ length: 21 }, (_, i) => String(2015 + i));
  const kd = [],
    pd = [],
    jd = [],
    sd = [],
    td = [];
  years.forEach((y) => {
    let k = 0,
      p = 0,
      j = 0,
      s = 0;
    teacherData.forEach((r) => {
      const v = Number(r[y]);
      if (r.segment === '幼儿园') k = v;
      if (r.segment === '小学') p = v;
      if (r.segment === '初中') j = v;
      if (r.segment === '普通高中') s = v;
    });
    kd.push(k);
    pd.push(p);
    jd.push(j);
    sd.push(s);
    td.push(k + p + j + s);
  });
  return {
    years,
    kindergartenData: kd,
    primaryData: pd,
    juniorData: jd,
    seniorData: sd,
    totalData: td,
  };
};

/* ---------- option：完全复刻 teacherChartOption ---------- */
const option = computed(() => {
  const { years, kindergartenData, primaryData, juniorData, seniorData } = prepareChartData();
  return {
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        let res = `${params[0].axisValue}<br/>`;
        let tot = 0;
        params.forEach((p) => {
          tot += p.value;
          res += `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background:${
            p.color
          }"></span>${p.seriesName}: ${p.value.toLocaleString()}<br/>`;
        });
        res += `<hr style="margin:5px 0;border:none;border-top:1px solid #ccc"><strong>全市合计: ${tot.toLocaleString()}</strong>`;
        return res;
      },
    },
    legend: { data: ['幼儿园', '小学', '初中', '普通高中'], top: 0 },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', data: years, axisLabel: { interval: 0, rotate: 45 } },
    yAxis: { type: 'value', name: '教师人数', axisLabel: { formatter: (v) => v.toLocaleString() } },
    series: [
      {
        name: '幼儿园',
        type: 'bar',
        stack: 'total',
        data: kindergartenData,
        itemStyle: { color: '#91cc75' },
        label: { show: true, position: 'top', fontSize: 10, color: '#333' },
      },
      {
        name: '小学',
        type: 'bar',
        stack: 'total',
        data: primaryData,
        itemStyle: { color: '#fac858' },
        label: { show: true, position: 'top', fontSize: 10, color: '#333' },
      },
      {
        name: '初中',
        type: 'bar',
        stack: 'total',
        data: juniorData,
        itemStyle: { color: '#ee6666' },
        label: { show: true, position: 'top', fontSize: 10, color: '#333' },
      },
      {
        name: '普通高中',
        type: 'bar',
        stack: 'total',
        data: seniorData,
        itemStyle: { color: '#73c0de' },
        label: { show: true, position: 'top', fontSize: 10, color: '#333' },
      },
    ],
  };
});

/* ---------- 初始化 & 响应式 ---------- */
function initChart() {
  chart = echarts.init(chartRef.value);
  chart.setOption(option.value);
  window.addEventListener('resize', () => chart?.resize());
}

onMounted(() => initChart());
</script>

<style scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>
